module.exports = function getResource(label, vars = []) {
    let resources = {
        near: 'Near',
        chooseLocation: 'Choose a location',
        cancel: 'Cancel',
        shareLocationAvailability: 'Share your location to see availability',
        chooseLocationTime: 'Choose Location & Time',
        chooseTime: 'Choose a Time',
        notAbleToFindStore: 'We were not able to find a store near',
        tryDifferentLocation: 'Please try a different location.',
        changeLocation: 'Change Location',
        noAppointmentsAvailable1: 'Sorry, there are no appointments',
        noAppointmentsAvailable2: 'available right now.',
        tryDifferentExperience: 'Please try a different experience.',
        seeWhatsHappening: 'See what’s happening',
        bookReservation: 'Book a Reservation',
        signUpForThisClass: 'Sign Up for This Class',
        reschedule: 'Reschedule',
        continueToBooking: 'Continue to Booking'
    };

    return resources[label];
};
